export default __webpack_public_path__ + "static/media/Web 1280 ΓÇô 3.0963fd6e.jpg";